import React, { useEffect, useState } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    padding: theme.spacing(1),
  },
}));

const QuizItem = ({
  question,
  onChange,
  cleanValue = false,
  setCleanValue,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (cleanValue) {
      setValue(null);
      setCleanValue(false);
    }
  }, [cleanValue, setValue, setCleanValue]);

  const handleChange = (event) => {
    setValue(event.target.value);
    const currentAnswer = question.answerOptions.filter(
      (answer) => answer.answerText === event.target.value
    );
    onChange(question.id, currentAnswer[0].isCorrect);
  };

  return (
    <FormControl
      classes={{ root: classes.root }}
      dir="rtl"
      component="fieldset"
    >
      <FormLabel component="legend">{question.questionText}</FormLabel>
      <RadioGroup
        aria-label="gender"
        name="gender1"
        value={value}
        onChange={handleChange}
      >
        <FormControlLabel
          value={question.answerOptions[0].answerText}
          control={<Radio />}
          label={question.answerOptions[0].answerText}
        />
        <FormControlLabel
          value={question.answerOptions[1].answerText}
          control={<Radio />}
          label={question.answerOptions[1].answerText}
        />
        <FormControlLabel
          value={question.answerOptions[2].answerText}
          control={<Radio />}
          label={question.answerOptions[2].answerText}
        />
        <FormControlLabel
          value={question.answerOptions[3].answerText}
          control={<Radio />}
          label={question.answerOptions[3].answerText}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default QuizItem;
